import { AdmissionDataRules } from './types/fieldRuleTypes';
import { defaultEarlyDateValidator, validatePISPASEP } from '../validator';

const placeHolders = {
  DATE: 'DD/MM/YYYY',
  INPUT: 'Digite aqui',
  SELECT: 'Selecione uma opção',
};
/**
 * Rules used when the form is first initialized and usually without data.
 */
const initialRules: AdmissionDataRules = {
  additionalBankingData: {},
  banking: {
    paymentMethod: {
      name: 'paymentMethod',
      required: false,
      label: 'Forma de Pagamento',
      placeholder: placeHolders.SELECT,
    },
    bank: {
      name: 'bank',
      required: false,
      label: 'Banco',
      placeholder: placeHolders.SELECT,
    },
    agency: {
      name: 'agency',
      required: false,
      label: 'Agência',
      placeholder: placeHolders.INPUT,
      rules: [{ type: 'string', max: 8 }],
    },
    account: {
      name: 'account',
      required: false,
      label: 'Conta',
      placeholder: placeHolders.INPUT,
      rules: [{ type: 'string', max: 20 }],
    },
    paymentMethodComplementaryRemuneration: {
      name: 'paymentMethodComplementaryRemuneration',
      required: false,
      label: 'Forma de Pagamento',
      placeholder: placeHolders.SELECT,
    },
    bankComplementaryRemuneration: {
      name: 'bankComplementaryRemuneration',
      required: false,
      label: 'Banco',
      placeholder: placeHolders.SELECT,
    },
    complementaryAgency: {
      name: 'complementaryAgency',
      required: false,
      label: 'Agência',
      placeholder: placeHolders.INPUT,
      rules: [{ type: 'string', max: 8 }],
    },
    complementaryAccount: {
      name: 'complementaryAccount',
      required: false,
      label: 'Conta',
      placeholder: placeHolders.INPUT,
      rules: [{ type: 'string', max: 20 }],
    },

  },
  dependents: [],
  professionalDocuments: {
    workCardType: {
      name: 'workCardType',
      required: true,
      label: 'Tipo de Carteira de Trabalho',
    },
    workCardNumber: {
      name: 'workCardNumber',
      required: true,
      label: 'Número CTPS',
      placeholder: placeHolders.INPUT,
      rules:[{type: 'string', max: 7}],
    },
    workCardSeries: {
      name: 'workCardSeries',
      required: true,
      label: 'Série',
      placeholder: placeHolders.INPUT,
      rules:[{type: 'string', max: 4}],
    },
    workCardState: {
      name: 'workCardState',
      required: true,
      label: 'Estado',
      placeholder: placeHolders.SELECT,
    },
    workCardIssuanceDate: {
      name: 'workCardIssuanceDate',
      required: false,
      label: 'Data Emissão',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    pisNumber: {
      name: 'pisNumber',
      required: false,
      label: 'Número',
      placeholder: placeHolders.INPUT,
      rules: [{ validator: validatePISPASEP }],
    },
    specialWorkClassNumber: {
      name: 'specialWorkClassNumber',
      required: false,
      label: 'Orgão de Classe',
      placeholder: placeHolders.SELECT,
    },
    specialWorkClassEnrollment: {
      name: 'specialWorkClassEnrollment',
      required: false,
      label: 'Número de Inscrição',
      placeholder: placeHolders.INPUT,
      rules: [{type: 'string', max: 14}],
    },
    specialWorkClassIssuanceDate: {
      name: 'specialWorkClassIssuanceDate',
      required: false,
      label: 'Data de Emissão',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    specialWorkClassValidityDate: {
      name: 'specialWorkClassValidityDate',
      required: false,
      label: 'Data de Validade',
      placeholder: placeHolders.DATE,
    },
  },
  personal: {
    birthPlace: {
      state: { name: ['birthPlace', 'state'], required: true, label: 'Estado de Nascimento', disabled: true },
      city: { name: ['birthPlace', 'city'], required: true, label: 'Cidade de Nascimento', disabled: true },
      country: { name: ['birthPlace', 'country'], required: true, label: 'País de Nascimento' },
    },
    contact: {
      cellphone: { name: ['contact', 'cellphone'], required: false, label: 'Celular' },
      dddCellPhone: {
        name: ['contact', 'dddCellPhone'],
        required: false, label: 'DDD',
        rules: [{ type: 'string', min: 2, max: 3 }],
      },
      landline: { name: ['contact', 'landline'], required: false, label: 'Telefone Fixo' },
      dddLandLine: {
        name: ['contact', 'dddLandLine'],
        required: false,
        label: 'DDD',
        rules: [{ type: 'string', min: 2, max: 3 }],
      },
    },
    information: {
      firstJob: {
        name: ['information', 'firstJob'],
        required: true,
        label: 'Primeiro Emprego',
        placeholder: placeHolders.SELECT,
      },
      socialSecurityBenefit: {
        name: ['information', 'socialSecurityBenefit'],
        required: true,
        label: 'Benefício previdenciário',
        placeholder: placeHolders.SELECT,
      },
      maritalStatus: { name: ['information', 'maritalStatus'], required: true, label: 'Estado Civil' },
      skinColor: { name: ['information', 'skinColor'], required: true, label: 'Cor da Pele' },
      educationLevel: { name: ['information', 'educationLevel'], required: true, label: 'Grau de Instrução' },
      email: { name: ['information', 'email'], disabled: true, required: true, label: 'E-mail pessoal' },
    },
    data: {
      gender: { name: ['data', 'gender'], required: true, label: 'Sexo' },
      cpf: { name: ['data', 'cpf'], disabled: true, placeholder: placeHolders.INPUT, label: 'CPF' },
      dateOfBirth: {
        name: ['data', 'dateOfBirth'],
        required: true,
        label: 'Data de Nascimento',
        rules: [{ validator: defaultEarlyDateValidator }],
      },

    },
    nameAffiliation: {
      father: {
        name: ['nameAffiliation', 'father'],
        required: false,
        placeholder: placeHolders.INPUT,
        label: 'Nome do Pai',
        rules: [{ min: 0, max: 60 }],
      },
      mother: {
        name: ['nameAffiliation', 'mother'],
        required: true,
        placeholder: placeHolders.INPUT,
        label: 'Nome da Mãe',
        rules: [{ min: 0, max: 60 }],
      },
      name: {
        name: ['nameAffiliation', 'name'],
        required: true,
        placeholder: placeHolders.INPUT,
        label: 'Nome',
        rules: [{ min: 0, max: 70 }],
      },
      socialName: {
        name: ['nameAffiliation', 'socialName'],
        required: false,
        placeholder: placeHolders.INPUT,
        label: 'Nome Social',
        rules: [{ min: 0, max: 70 }],
      },
    },
  },
  address: {
    cep: { name: 'cep', required: true, label: 'Caixa Postal (CEP)' },
    streetType: { name: 'streetType', required: true, label: 'Tipo de Logradouro' },
    street: { name: 'street', required: true, label: 'Logradouro', rules: [{ min: 0, max: 80 }] },
    number: { name: 'number', required: false, label: 'Número' },
    complement: { name: 'complement', required: false, label: 'Complemento', rules: [{ min: 0, max: 80 }] },
    neighborhood: { name: 'neighborhood', required: false, label: 'Bairro', rules: [{ min: 0, max: 80 }] },
    country: { name: 'country', required: true, label: 'País' },
    city: { name: 'city', required: true, label: 'Cidade' },
    state: { name: 'state', required: true, label: 'Estado' },
  },
  personalDocuments: {
    foreigner: { name: 'foreigner', required: false, defaultValue: false },
    idCard: { label: 'Número', placeholder: placeHolders.INPUT, name: 'idCard', required: true },
    idCardIssuingState: { name: 'idCardIssuingState', label: 'UF', placeholder: placeHolders.SELECT, required: true },
    idCardIssuanceDate: {
      name: 'idCardIssuanceDate',
      required: true,
      label: 'Data de emissão',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    idCardIssuingAuthority: {
      name: 'idCardIssuingAuthority',
      label: 'Orgão Emissor',
      placeholder: placeHolders.INPUT,
      required: true,
    },
    rneCardIssuanceDate: {
      name: 'rneCardIssuanceDate',
      label: 'Data de emissão',
      placeholder: placeHolders.DATE,
      hidden: true,
      disabled: true,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    rneCard: {
      name: 'rneCard',
      label: 'RNE (Sem pontuação)',
      placeholder: placeHolders.INPUT,
      hidden: true,
      disabled: true,
    },
    rneCardIssuingAuthority: {
      name: 'rneCardIssuingAuthority',
      label: 'Orgão Emissor RNE',
      placeholder: placeHolders.INPUT,
      hidden: true,
      disabled: true,
    },
    foreignerCountryArrivalDate: {
      name: 'foreignerCountryArrivalDate',
      label: 'Data de chegada no país',
      placeholder: placeHolders.DATE,
      hidden: true,
      disabled: true,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    foreignerRneCountry: {
      name: 'foreignerRneCountry',
      label: 'País',
      placeholder: placeHolders.SELECT,
      hidden: true,
      disabled: true,
    },
    foreignerNationalityCode: {
      name: 'foreignerNationalityCode',
      label: 'Naturalidade',
      placeholder: placeHolders.SELECT,
      hidden: true,
      disabled: true,
    },
    foreignerEntryCondition: {
      name: 'foreignerEntryCondition',
      label: 'Condição de ingresso',
      placeholder: placeHolders.SELECT,
      hidden: true,
      disabled: true,
    },
    foreignerIsMarriedWithBrazilian: {
      name: 'foreignerIsMarriedWithBrazilian',
      label: 'Casado com brasileiro(a)',
      hidden: true,
      placeholder: placeHolders.SELECT,
      disabled: true,
    },
    foreignerHasChildrenWithBrazilian: {
      name: 'foreignerHasChildrenWithBrazilian',
      label: 'Filhos com brasileiros',
      hidden: true,
      placeholder: placeHolders.SELECT,
      disabled: true,
    },
    voterRegistrationNumber: {
      name: 'voterRegistrationNumber',
      disabled: false,
      required: false,
      label: 'Número',
      placeholder: placeHolders.INPUT,
    },
    voterRegistrationZone: {
      name: 'voterRegistrationZone',
      disabled: true,
      required: false,
      label: 'Zona',
      placeholder: placeHolders.INPUT,
    },
    voterRegistrationSection: {
      name: 'voterRegistrationSection',
      disabled: true,
      required: false,
      label: 'Seção',
      placeholder: placeHolders.INPUT,
    },
    voterRegistrationState: {
      name: 'voterRegistrationState',
      disabled: true,
      required: false,
      label: 'UF',
      placeholder: placeHolders.SELECT,
    },
    ricNumber: {
      name: 'ricNumber',
      required: false,
      label: 'Número',
      placeholder: placeHolders.INPUT,
    },
    ricIssuingAuthority: {
      name: 'ricIssuingAuthority',
      required: false,
      label: 'Orgão Emissor',
      placeholder: placeHolders.INPUT,
    },
    ricExpeditionDate: {
      name: 'ricExpeditionDate',
      required: false,
      label: 'Data de Expedição',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    driverLicenseNumber: {
      name: 'driverLicenseNumber',
      required: false,
      label: 'Número',
      placeholder: placeHolders.INPUT,
    },
    driverLicenseExpiryDate: {
      name: 'driverLicenseExpiryDate',
      required: false,
      label: 'Data de vencimento',
      placeholder: placeHolders.DATE,
    },
    driverLicenseExpeditionDate: {
      name: 'driverLicenseExpeditionDate',
      required: false,
      label: 'Data de expedição',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    driverLicenseFirstExpeditionDate: {
      name: 'driverLicenseFirstExpeditionDate',
      required: false,
      label: 'Data 1a. habilitação',
      placeholder: placeHolders.DATE,
      rules: [{ validator: defaultEarlyDateValidator }],
    },
    driverLicenseCategory: {
      name: 'driverLicenseCategory',
      required: false,
      label: 'Categoria',
      placeholder: placeHolders.INPUT,
    },
    driverLicenseState: {
      name: 'driverLicenseState',
      required: false,
      label: 'UF',
      placeholder: placeHolders.SELECT,
    },
    militaryReserveNumber: {
      name: 'militaryReserveNumber',
      required: false,
      hidden: true,
      disabled: true,
      label: 'Número',
      placeholder: placeHolders.INPUT,
    },
    militaryReserveSeries: {
      name: 'militaryReserveSeries',
      required: false,
      hidden: true,
      disabled: true,
      label: 'Série',
      placeholder: placeHolders.INPUT,
    },
    militaryReserveCategory: {
      name: 'militaryReserveCategory',
      required: false,
      hidden: true,
      disabled: true,
      label: 'Categoria',
      placeholder: placeHolders.INPUT,
      rules: [{type: 'string', min: 1, max:2}],
    },
    militaryReserveState: {
      name: 'militaryReserveState',
      required: false,
      hidden: true,
      disabled: true,
      label: 'UF',
      placeholder: placeHolders.SELECT,
    },
  },
};
export default initialRules;